import {Icon} from 'antd';

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1120110_ak67i8l6ein.js',
});

export default IconFont;
